import { Button, Empty, Form, Input, Modal, Space } from "antd";

export default function KnowledgeCrawlModal({ open, crawling, logs, saveStatusText, onCancel, onStart, onStop }) {
  const [form] = Form.useForm();

  const handleStart = async () => {
    try {
      const values = await form.validateFields();
      await onStart?.(values);
    } catch (error) {}
  };

  return (
    <Modal
      title="从链接采集"
      open={open}
      centered
      width={720}
      onCancel={onCancel}
      footer={
        <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>
          <div style={{ minHeight: 22, color: "#6b7280" }}>{saveStatusText || ""}</div>
          <Space>
            <Button key="cancel" onClick={onCancel} disabled={crawling}>
              关闭
            </Button>
            <Button
              key="start"
              type={crawling ? "default" : "primary"}
              danger={crawling}
              onClick={crawling ? onStop : handleStart}
            >
              {crawling ? "停止采集" : "开始采集"}
            </Button>
          </Space>
        </div>
      }
    >
      <Form form={form} layout="vertical">
        <Form.Item label="网站链接：" name="url" rules={[{ required: true, message: "请输入网站链接" }]}>
          <Input placeholder="请输入要采集的网站链接" disabled={crawling} />
        </Form.Item>
        <Form.Item label="AI密钥(DeepSeek)：" name="apiKey" rules={[{ required: true, message: "请输入AI密钥" }]}>
          <Input placeholder="请输入AI密钥" disabled={crawling} />
        </Form.Item>
      </Form>

      <div
        style={{
          height: 280,
          overflowY: "auto",
          padding: 16,
          background: "#fafafa",
          border: "1px solid #f0f0f0",
          borderRadius: 8,
        }}
      >
        {logs.length === 0 ? (
          <div style={{ height: "100%", display: "flex", alignItems: "center", justifyContent: "center" }}>
            <Empty description="开始采集后显示过程日志" />
          </div>
        ) : (
          logs.map((item, index) => (
            <div
              key={`${index}-${item}`}
              style={{ marginBottom: 8, whiteSpace: "pre-wrap", wordBreak: "break-word", color: "#111827" }}
            >
              {item}
            </div>
          ))
        )}
      </div>
    </Modal>
  );
}
